import { useQueryParamContext } from 'modules/iterableGoals/contexts';
import { useGoalsTranslations } from 'modules/iterableGoals/hooks';
import { HeaderSubSectionWrapper, StyledHeader, StyledPageHeader } from './Styled';

const HeaderSubSection = () => {
  const { t } = useGoalsTranslations();
  return (
    <HeaderSubSectionWrapper>
      {t('dynamic.analyticsPageSubHeading.text', {
        campaigns: 12,
        date: 'May 31, 2022 4:34 PM PST',
      })}
    </HeaderSubSectionWrapper>
  );
};

export const GoalAnalyticsHeaderLater = () => {
  const { t } = useGoalsTranslations();
  return (
    <StyledPageHeader
      data-test="goal-analytics-page-header"
      breadcrumb={{
        href: '#',
        content: t('heading.analytics.breadcrumb'),
      }}
      pageSubSection={<HeaderSubSection />}
      documentTitle={t('heading.analytics.pageTitle')}
    >
      add_to_cart
    </StyledPageHeader>
  );
};

export const GoalAnalyticsHeader = () => {
  const { goalName } = useQueryParamContext();

  return <StyledHeader data-testid="goal-analytics-page-header">{goalName}</StyledHeader>;
};
